import React from "react"
import { Typography } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"

import { AppLinksBlock } from "@components"
import { dateFormatReceiver } from "@utils"

export default function ReportHomeListTableReadyBlock(
	{
		date,
		reportExecutionID,
		officeID,
		hasCompetitionSites,
		hasDirectSites,
		pickUp,
		noResults,
		hasGenerate,
		hasExport
	}) {
	return <>
		<Typography variant="caption" sx={{ mb: 1 }}>
			{formatDate(date, {
				isString: true,
				format: 'dd MMM yyyy HH:mm',
				receivedFormat: dateFormatReceiver(date)
			})}
		</Typography>
		{!noResults && <AppLinksBlock
			downMultiReport={hasGenerate}
			downMultiExport={hasExport}
			hasCompetitionSites={hasCompetitionSites}
			hasDirectSites={hasDirectSites}
			reportExecutionID={reportExecutionID}
			officePickupID={officeID}
			pickUp={pickUp}
			showMatches={true}
		/>}
	</>
}